import { Link } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta';

export default function NotFound() {
  usePageMeta({ title: 'Page not found', noindex: true });
  return (
    <div className="not-found">
      <h2>404</h2>
      <p>The page you're looking for doesn't exist.</p>
      <Link to="/">Back to Dashboard</Link>
    </div>
  );
}
